angular.module('qkr.inventory').factory('inventoryItemService', ['$routeParams', '$rootScope', '$q', 'merchantService', 'outletService', 'inventoryService', 'variantService', 'taxService', 'utils', 'appConfig', 'gettextCatalog', 'taxRateToPercentageFilter',
    function($routeParams, $rootScope, $q, merchantService, outletService, inventoryService, variantService, taxService,
             utils, appConfig, gettextCatalog, taxRateToPercentageFilter, messageService) {
        const cleanProductForCloning = function(productForCloning) {
            delete (productForCloning.id);
            delete (productForCloning.sku);
            productForCloning.name = '';

            angular.forEach(productForCloning.variants, (variant) => {
                delete (variant.id);
                variant.variantId = null;

                angular.forEach(variant.variantDetails, (variantDetail) => {
                    delete (variantDetail.id);
                });
            });

            return productForCloning;
        };

        const cleanProductForEditing = function(productForEditing) {
            angular.forEach(productForEditing.variants, (variant) => {
                variant.variantId = angular.copy(variant.id);
                delete (variant.id);
            });

            productForEditing.variants.sort((variantA, variantB) => variantA.priority - variantB.priority);

            return productForEditing;
        };

        const setupProductForCreation = function(productName) {
            const deferred = $q.defer();

            if ($rootScope.merchantInfo != null) {
                const newProduct = {name: productName, currency: $rootScope.merchantInfo.defaultCurrency};
                deferred.resolve(newProduct);
            } else {
                merchantService.refreshMerchantInfo().then((merchantInfo) => {
                    const newProduct = {name: productName, currency: merchantInfo.defaultCurrency};
                    deferred.resolve(newProduct);
                });
            }
            return deferred.promise;
        };

        const getMerchant = function() {
            const deferred = $q.defer();
            if ($rootScope.merchantInfo != null) {
                deferred.resolve($rootScope.merchantInfo);
            } else {
                merchantService.refreshMerchantInfo().then((merchantInfo) => {
                    deferred.resolve(merchantInfo);
                });
            }

            return deferred.promise;
        };

        const getOutlet = function(isOutletLevel) {
            const deferred = $q.defer();
            if (isOutletLevel) {
                if ($rootScope.outletInfo != null) {
                    deferred.resolve($rootScope.outletInfo);
                } else {
                    outletService.refreshOutletInfo().then((outletInfo) => {
                        deferred.resolve(outletInfo);
                    });
                }
            } else {
                deferred.resolve(null);
            }

            return deferred.promise;
        };

        const getProduct = function(isNewProduct, isClonedProduct, productName) {
            const deferred = $q.defer();

            if (isClonedProduct) {
                inventoryService.loadInventoryItem($routeParams.id).then((product) => {
                    deferred.resolve(cleanProductForCloning(product));
                });
            } else if (isNewProduct) {
                deferred.resolve(setupProductForCreation(productName));
            } else {
                inventoryService.loadInventoryItem($routeParams.id).then((product) => {
                    deferred.resolve(cleanProductForEditing(product));
                });
            }

            return deferred.promise;
        };

        const getStockLevelsForProductAndOutlet = function(isNewProduct, productPromise, outletPromise) {
            const deferred = $q.defer();

            if (!isNewProduct) {
                productPromise.then((product) => {
                    outletPromise.then((outlet) => {
                        if (outlet != null) {
                            inventoryService.getStockLevelsForProductInCurrentOutlet(product).then((promise) => {
                                deferred.resolve(promise.data);
                            });
                        } else {
                            deferred.resolve(null);
                        }
                    });
                });
            } else {
                deferred.resolve(null);
            }

            return deferred.promise;
        };

        const applyStockLevelsToProduct = function(isNewProduct, productPromise, stockLevelsPromise) {
            if (!isNewProduct) {
                productPromise.then((product) => {
                    stockLevelsPromise.then((stockLevels) => {
                        if (stockLevels != null) {
                            angular.forEach(product.variants, (variant) => {
                                for (let i = 0; i < stockLevels.length; i++) {
                                    const stockLevel = stockLevels[i];

                                    if (stockLevel.productVariantId == variant.variantId) {
                                        variant.currentStockQuantity = stockLevel.quantityAvailable;
                                        variant.stockQuantity = stockLevel.quantityAvailable;
                                        break;
                                    }
                                }
                            });

                            if (product.hasSystemDefaultVariant && stockLevels.length == 1) {
                                product.currentStockQuantity = stockLevels[0].quantityAvailable;
                                product.stockQuantity = stockLevels[0].quantityAvailable;
                            }
                        }
                    });
                });
            }
        };

        const getVariantInfrastructure = function(productPromise, maxVariants) {
            const deferred = $q.defer();

            productPromise.then((product) => {
                deferred.resolve(variantService.getVariantInfrastructure(product.variants, maxVariants));
            });

            return deferred.promise;
        };

        const getVariantSetsFromInfrastructure = function(variantInfrastructurePromise) {
            const deferred = $q.defer();

            variantInfrastructurePromise.then((variantInfrastructure) => {
                const variantSets = variantService.getVariantSetsFromInfrastructure(variantInfrastructure);
                deferred.resolve(variantSets);
            });

            return deferred.promise;
        };

        const getVariantTitleListFromInfrastructure = function(variantInfrastructurePromise) {
            const deferred = $q.defer();

            variantInfrastructurePromise.then((variantInfrastructure) => {
                const variantTitleList = variantService.getVariantTitleListFromInfrastructure(variantInfrastructure);
                deferred.resolve(variantTitleList);
            });

            return deferred.promise;
        };

        const getVariantTypesFromInfrastructure = function(variantInfrastructurePromise) {
            const deferred = $q.defer();

            variantInfrastructurePromise.then((variantInfrastructure) => {
                const variantTypes = variantService.getVariantTypesFromInfrastructure(variantInfrastructure);
                deferred.resolve(variantTypes);
            });

            return deferred.promise;
        };

        const getVariantConfig = function(productPromise, maxVariants, maxVariantSets, skuPlaceholderText) {
            const deferred = $q.defer();

            const variantInfrastructure = getVariantInfrastructure(productPromise, maxVariants);
            const variantTypes = getVariantTypesFromInfrastructure(variantInfrastructure);
            const variantSets = getVariantSetsFromInfrastructure(variantInfrastructure);
            const variantTitleList = getVariantTitleListFromInfrastructure(variantInfrastructure);
            const skusInUse = getSkusInUse();

            const resolveList = [variantInfrastructure, variantTypes, variantSets, variantTitleList, skusInUse];

            $q.all(resolveList).then((results) => {
                const variantConfig = {
                    variantInfrastructure: results[0],
                    maxVariantSets,
                    maxVariants,
                    addVariantTypes: results[1],
                    variantSets: results[2],
                    variantTitleList: results[3],
                    skuPlaceholderText,
                    skusInUse: results[4]
                };

                deferred.resolve(variantConfig);
            });

            return deferred.promise;
        };

        const getCategories = function() {
            const deferred = $q.defer();

            inventoryService.loadProductCategoriesForInventory().then((categories) => {
                deferred.resolve(categories);
            });

            return deferred.promise;
        };

        const getOptionSets = function() {
            const deferred = $q.defer();

            inventoryService.loadOptionSets().then((optionSets) => {
                deferred.resolve(optionSets);
            });

            return deferred.promise;
        };

        const getBehaviour = function(merchantPromise, behaviour) {
            const deferred = $q.defer();

            merchantPromise.then((merchant) => {
                deferred.resolve(merchantService.behaviour(merchant, behaviour));
            });

            return deferred.promise;
        };

        const isOptionSetInList = function(optionSetList, optionSet) {
            if (!utils.hasNoValue(optionSetList)) {
                for (let j = 0; j < optionSetList.length; j++) {
                    const optionSetInList = optionSetList[j];
                    if (optionSetInList.id == optionSet.id) {
                        return true;
                    }
                }
            }
            return false;
        };

        const getTaxRates = function(merchantPromise, outletPromise, outletLevel) {
            const deferred = $q.defer();

            if (outletLevel) {
                merchantPromise.then((merchantInfo) => {
                    if (merchantInfo.taxCalculationsEnabled) {
                        taxService.getTaxRatesForOutlet().then(
                            (outletTaxRates) => {
                                deferred.resolve(outletTaxRates);
                            }
                        );
                    } else {
                        deferred.resolve(null);
                    }
                });
            } else {
                merchantPromise.then((merchantInfo) => {
                    if (merchantInfo.taxCalculationsEnabled) {
                        taxService.getTaxRatesForMerchant(merchantInfo.id).then(
                            (merchantTaxRates) => {
                                deferred.resolve(merchantTaxRates);
                            }
                        );
                    } else {
                        deferred.resolve(null);
                    }
                });
            }

            return deferred.promise;
        };

        const getSelectedTaxRates = function(taxPromise, productPromise, outletLevel, isNewProduct) {
            const deferred = $q.defer();

            if (isNewProduct) {
                deferred.resolve(null);
            } else {
                taxPromise.then((taxRates) => {
                    if (taxRates) {
                        productPromise.then((productInfo) => {
                            if (outletLevel) {
                                taxService.getOutletTaxRateForInventoryItem(productInfo.id).then((selectedTaxRates) => {
                                    deferred.resolve(selectedTaxRates);
                                });
                            } else {
                                taxService.getMerchantTaxRatesForInventoryItem(productInfo.id).then((selectedTaxRates) => {
                                    deferred.resolve(selectedTaxRates);
                                });
                            }
                        });
                    } else {
                        deferred.resolve(null);
                    }
                });
            }

            return deferred.promise;
        };

        const getMinMaxTaxString = function(taxPromise) {
            const deferred = $q.defer();

            taxPromise.then((taxRates) => {
                if (taxRates && taxRates.applicableTaxRates && taxRates.applicableTaxRates.length > 1) {
                    let min = taxRates.applicableTaxRates[0].taxRates[0].applicableTaxRate;
                    let max = taxRates.applicableTaxRates[0].taxRates[0].applicableTaxRate;

                    angular.forEach(taxRates.applicableTaxRates, (taxGroup) => {
                        angular.forEach(taxGroup.taxRates, (taxRate) => {
                           if (taxRate.applicableTaxRate < min) {
                               min = taxRate.applicableTaxRate;
                           } else if (taxRate.applicableTaxRate > max) {
                               max = taxRate.applicableTaxRate;
                           }
                        });
                    });
                    deferred.resolve(taxRateToPercentageFilter(min) + '-' + taxRateToPercentageFilter(max));
                } else {
                    deferred.resolve(null);
                }
            });

            return deferred.promise;
        };
        
        const checkIsTaxChangeable = function(applicableTaxRates) {
        	let result = false;
        	
        	angular.forEach(applicableTaxRates, (applicableTaxRate) => {
        		if (applicableTaxRate.taxRates && applicableTaxRate.taxRates.length > 1) {
        			result = true;
        		}
        	});
        	
        	return result;
        };

        const checkIsSalesTaxChangeable = function(salesTax) {
            if (salesTax === null || angular.equals({}, salesTax)) {
                return false;
            }

            return (salesTax.taxRates && salesTax.taxRates.length > 1);
        };

        const getTaxConfigMap = function(merchantPromise, productPromise, outletPromise, isNewProduct) {
            const deferred = $q.defer();

            const taxRatesPromise = getTaxRates(merchantPromise, outletPromise, appConfig.outletLevel);
            const selectedTaxRatesPromise = getSelectedTaxRates(taxRatesPromise, productPromise, appConfig.outletLevel, isNewProduct);
            const minMaxTaxStrPromise = getMinMaxTaxString(taxRatesPromise);

            merchantPromise.then((merchantInfo) => {
                if (merchantInfo.taxCalculationsEnabled) {
                    $q.all([taxRatesPromise, selectedTaxRatesPromise, productPromise, minMaxTaxStrPromise]).then((results) => {
                        const taxConfig = {};
                        const taxRates = results[0];
                        const selectedTaxRates = results[1];
                        const product = results[2];
                        const minMaxTaxStr = results[3];

                        taxConfig.taxConfigurationChanges = false;
                        taxConfig.outletLevel = appConfig.outletLevel;
                        taxConfig.isNewProduct = isNewProduct;
                        taxConfig.applicableTaxRates = (!appConfig.outletLevel && merchantInfo.taxCalculationsEnabled) ? taxRates.applicableTaxRates : [];
                        taxConfig.explicitTaxRates = selectedTaxRates;
                        taxConfig.salesTax = (appConfig.outletLevel && merchantInfo.taxCalculationsEnabled) ? taxRates : null;
                        taxConfig.useTaxSection = (!appConfig.outletLevel && taxRates.applicableTaxRates.length > 1);
                        taxConfig.currentProduct = product;
                        taxConfig.updatedSalesTaxList = [];
                        taxConfig.minMaxTaxStr = minMaxTaxStr;
                        taxConfig.isTaxChangeable = checkIsTaxChangeable(taxRates.applicableTaxRates);
                        taxConfig.isSalesTaxChangeable = checkIsSalesTaxChangeable(taxConfig.salesTax);

                        deferred.resolve(taxConfig);
                    }, (reason) => {
                        messageService.error('There was a problem getting tax configuration for this product');
                    });
                } else {
                    deferred.resolve(null);
                }
            });

            return deferred.promise;
        };

        const getMenuWarningMessageForProduct = function(productPromise) {
            const deferred = $q.defer();

            productPromise.then((product) => {
                if (product.id != null) {
                    inventoryService.findInventoryItemInMenus(product.id).then((menuList) => {
                        let confMsg = null;
                        if (!utils.hasNoValue(menuList)) {
                            if (menuList.length == 1) {
                                confMsg = gettextCatalog.getString('Warning! Editing this product will affect the following items:') + utils.summarizeListWithCouponAndMenuNames(menuList, false) + ' ';
                            } else if (menuList.length > 1) {
                                confMsg = gettextCatalog.getString('Warning! Editing this product will affect the following items:') + ' ' + utils.summarizeListWithCouponAndMenuNames(menuList, false) + ' ';
                            }
                        }
                        deferred.resolve(confMsg);
                    });
                } else {
                    deferred.resolve(null);
                }
            });

            return deferred.promise;
        };

        var getSkusInUse = function() {
            const deferred = $q.defer();

            merchantService.getSkusInUse().then((skusInUse) => {
                deferred.resolve(skusInUse);
            });

            return deferred.promise;
        };

        return {
            resolve(isNewProduct, isClonedProduct, productName) {
                const merchant = getMerchant();
                const outlet = getOutlet(appConfig.outletLevel);
                const product = getProduct(isNewProduct, isClonedProduct, productName);

                const stockLevels = getStockLevelsForProductAndOutlet(isNewProduct, product, outlet);
                applyStockLevelsToProduct(isNewProduct, product, stockLevels);

                const maxVariantSets = 3;
                const maxVariants = 100;
                const skuPlaceholderText = gettextCatalog.getString('Automatic');
                const variantConfig = getVariantConfig(product, maxVariants, maxVariantSets, skuPlaceholderText);
                const categories = getCategories();
                const optionSets = getOptionSets();
                const allowEditOnOutletLevel = getBehaviour(merchant, 'inventoryPage.allowEditOnOutletLevel');
                const showAgeRestriction = getBehaviour(merchant, 'inventoryItemPage.showAgeRestriction');
                const showStockLevel = getBehaviour(merchant, 'inventoryItemPage.showStockLevel');
                const menuWarningMessage = getMenuWarningMessageForProduct(product);
                const taxConfig = getTaxConfigMap(merchant, product, outlet, isNewProduct);

                const resolveList = [merchant, outlet, product, stockLevels, variantConfig, categories, optionSets,
                    allowEditOnOutletLevel, showAgeRestriction, showStockLevel, menuWarningMessage, taxConfig];

                return $q.all(resolveList).then((results) => ({
                        merchant: results[0],
                        outlet: results[1],
                        product: results[2],
                        stockLevels: results[3],
                        skuPlaceholderText,
                        variantConfig: results[4],
                        isNewProduct,
                        isClonedProduct,
                        categories: results[5],
                        optionSets: results[6],
                        allowEditOnOutletLevel: results[7],
                        showAgeRestriction: results[8],
                        showStockLevel: results[9],
                        menuWarningMessage: results[10],
                        taxConfig: results[11]
                    }));
            },

            getUnselectedOptionSets(optionSetList, selectedOptionSetList) {
                const unselectedOptionSets = [];
                angular.forEach(optionSetList, (optionSetInList) => {
                    if (!isOptionSetInList(selectedOptionSetList, optionSetInList)) {
                        unselectedOptionSets.push(optionSetInList);
                    }
                });

                return unselectedOptionSets;
            }
        };
}]);



// WEBPACK FOOTER //
// ./src/inventory/services/inventoryItem.services.js